import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ClientUsersManager } from "@/components/ClientUsersManager";

export default function ClientUsersPage() {
  const { user } = useAuth();
  if (user?.client_role !== "DONO") return <Navigate to="/" replace />;

  return (
    <div className="space-y-6" data-testid="client-users-page">
      <header>
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-medium">Minha empresa</p>
        <h1 className="font-heading text-3xl font-bold mt-1">Usuários</h1>
        <p className="mt-1 text-sm text-muted-foreground">Gerencie quem da sua empresa pode acessar o Portal BAUEN.</p>
      </header>
      <ClientUsersManager clientId={user.client_id} />
    </div>
  );
}
